import { render, staticRenderFns } from "./manybo-turnstile.vue?vue&type=template&id=397ea4f6"
import script from "./manybo-turnstile.vue?vue&type=script&lang=js"
export * from "./manybo-turnstile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports